// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-P":"P_dpu-detail-P__cPvQ0"};